// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2BCjt","list":"styles_list__r2j4n"};